import { connect } from 'react-redux';
import Illustration from './Illustration';
import { setIsFileLoadingFailed } from '../screen/screenActions';

const mapDispatchToProps = (dispatch) => ({
    onImageLoadError: () => {
        dispatch(setIsFileLoadingFailed(true));
    },
});

const IllustrationContainer = connect(
    null,
    mapDispatchToProps,
)(Illustration);

export default IllustrationContainer;
